/**
 * Faixa de etapas da fila (Expedição, Garantias): cada etapa é um atalho com a
 * contagem, e a etapa ativa fica destacada. Substitui o parágrafo corrido
 * "Composição por etapa: A: 0 · B: 0" — mesma informação, lida de relance.
 * Só apresentação: contagens e rótulos vêm do dataset, nada é calculado aqui.
 */
import React, { type ReactElement } from "react";
import { Link } from "react-router-dom";

export interface StageStripItem {
  key: string;
  label: string;
  count: number;
  to: string;
}

export function StageStrip({
  items,
  activeKey = null,
  ariaLabel,
  total,
  ...rest
}: {
  items: StageStripItem[];
  activeKey?: string | null;
  ariaLabel: string;
  total: number;
  [dataAttr: `data-${string}`]: string | number | undefined;
}): ReactElement {
  return (
    <nav aria-label={ariaLabel} className="flex flex-col gap-2" {...rest}>
      <ul className="m-0 flex list-none flex-wrap gap-2 p-0">
        {items.map((item) => {
          const active = item.key === activeKey;
          return (
            <li key={item.key}>
              <Link
                to={item.to}
                aria-current={active ? "true" : undefined}
                className={
                  "inline-flex items-center gap-2 rounded-pill border px-3 py-1.5 text-sm font-bold transition-colors " +
                  (active ? "border-brand bg-brand-wash text-brand-text" : "border-border bg-surface text-ink hover:border-ink")
                }
              >
                {item.label}
                <span
                  className={
                    "min-w-[1.5rem] rounded-pill px-1.5 text-center text-xs font-black tabular-nums " +
                    (item.count > 0 ? "bg-brand text-on-brand" : "bg-surface-soft text-muted")
                  }
                >
                  {item.count}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
      <span className="sr-only">{`${total} no total`}</span>
    </nav>
  );
}
